<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-1">
<div class="heading heading-with-title heading-without-image" id="chapter-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-with-element-number">
<div class="element-number-block">
<div class="element-number">1</div>
</div>
<div class="title-block">
<h1 class="title">1999</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">“A</span>ll stand.”</p>
<p class="subsq">I sat nervously in the corridor, jiggling my right leg as the usher's voice seeped through the oak panelled door to Court No. 1.</p>
<p class="subsq">“Feckin’ hell Mave, it’s not the trial of the century, it’s a simple shoplifting job with a Common Assault.” Bob blew his nose, inspected what was deposited on the greying handkerchief, folded it over and shoved it back in his trouser pocket.</p>
<p class="subsq">“Fine for you to say, but you’re not the one giving evidence against your own dad, are you?” I flicked through my notebook, giving the neat handwriting a once over. For the first time in my career I didn’t need to memorise my evidence, this job would be etched in my brain for all eternity and beyond.</p>
<p class="subsq">I, Mavis Jane Upton, or better known to my colleagues and bosses over the previous ten years as Constable 1261 Mavis Upton, ace police driver, apprehender of naughty people, lover of crisps (any flavour) and hater of big knickers, had undertaken, albeit unwittingly, the job of arresting my own itinerant, belligerent and delinquent father. A father I hadn’t set eyes on since 1962 when I was four years old.</p>
<p class="subsq">I looked out of the tall, sandstone-edged window and watched a single white cloud scoot across the blue sky.</p>
<p class="subsq">Arthur Albert Upton.</p>
<p class="subsq"><i>My dad.</i></p>
<p class="subsq"><i>My drunk dad.</i></p>
<p class="subsq"><i>My missing for over thirty-five years dad.</i></p>
<p class="subsq">The dad who thought leaving a one-page note and a yellowing coupon for a moulded foam cup bra just like Jayne Mansfield wore, would be sufficient to explain away his abandonment. The dad who felt having a police officer for a daughter was something to be ashamed of. I bristled with betrayal. I’d read the court reports attached to the CPS file. His defence was centred around his long-term love affair with several bottles of Johnnie Walker and a well-documented diagnosis of dementia.</p>
<p class="subsq"><i>Well it wasn’t going to wash with me. The Court might give him a chance but I sure as hell wouldn’t.</i></p>
<p class="subsq">I sighed, trying to fight off a brief feeling of pity that had started to gnaw at my stomach. As far as I was concerned, he didn’t deserve pity, in fact he didn’t deserve any emotion I could rustle up.</p>
<p class="subsq">“Dementia is just when you forget things isn’t it, Bob?”</p>
<p class="subsq">“I suppose so, probably a bit more to it than that, Mave, but that’s probably the gist of it, why?”</p>
<p class="subsq">I fiddled with the crested police pin, pushing the popper back into place through my black &amp; white chequered tie so it sat neatly. “I was just wondering what he’s going to come up with in Court that’s all.”</p>
<p class="subsq">I stood up to shake some feeling back into my leg, shuddering as pins and needles quickly made their way into my foot. I stamped my highly-polished boot on the woodblock flooring, feeling anger and contempt pushing to the surface again.</p>
<p class="subsq"><i>“Oooh, sorry your Worships, I just picked up three bottles of Morrisons finest Scotch...” </i>I threw up a salute, just as Dad had in the Custody Suite when he’d proudly announced his rank in the Navy.</p>
<p class="subsq"><i>“.… and forgot I’d shoved two down my trousers and one inside my jacket before I ran out of the store like a gorilla with a pair of swollen crotch nuggets,” </i>I mimicked, whilst pulling a face.</p>
<p class="subsq">Bob laughed and snorted down his nose which called for another vigorous wipe with his crumpled, crusty hanky.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-001.vue?aea43fca